module.exports = __webpack_public_path__ + "static/media/empty.bec03ac4.png";